export default "__VITE_ASSET__DpkNTo8x__"